import { gql } from "@shane32/graphql";

export const AddAddressMutation = gql`
    mutation ($address: AddressInputGraph!) {
        v1 {
            shippingAddress {
                add(address: $address) {
                    id
                    country {
                        id
                        name
                    }
                    firstName
                    lastName
                    company
                    email
                    address1
                    address2
                    city
                    stateProvince {
                        id
                        name
                        abbreviation
                    }
                    zipPostalCode
                    phoneNumber
                    createdOnUtc
                }
            }
        }
    }
`;

export interface IAddress {
    id: string;
    country: {
        id: string;
        name: string;
    };
    firstName: string;
    lastName: string;
    company: string | null;
    email: string;
    address1: string;
    address2: string | null;
    city: string;
    stateProvince: {
        id: string;
        name: string;
        abbreviation: string | null;
    } | null;
    zipPostalCode: string;
    phoneNumber: string;
    createdOnUtc: string;
}

export interface IAddAddressMutationResult {
    v1: {
        shippingAddress: {
            add: IAddress;
        };
    };
}

export interface IAddAddressMutationVariables {
    address: {
        countryId: string;
        firstName: string;
        lastName: string;
        company?: string | null;
        address1: string;
        address2?: string | null;
        city: string;
        stateProvinceId?: string | null;
        zipPostalCode: string;
        phoneNumber: string;
        emailAddress?: string | null;
    };
}
